import { useEffect } from 'react';
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ErrorBoundary from "./components/ErrorBoundary";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import Admin from "./pages/Admin";
import Applications from "./pages/Applications";
import Dobrovolnictvo from "./pages/Dobrovolnictvo";
import VisitorsGuide from "./pages/VisitorsGuide";
import WhistleBlower from "./pages/WhistleBlower";

const queryClient = new QueryClient();

// Google Analytics and Performance Monitoring
const useAppInitialization = () => {
  useEffect(() => {
    // Google Analytics 4
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = 'https://www.googletagmanager.com/gtag/js?id=GA_MEASUREMENT_ID';
    document.head.appendChild(script1);

    const script2 = document.createElement('script');
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'GA_MEASUREMENT_ID', {
        page_path: window.location.pathname,
      });
    `;
    document.head.appendChild(script2);

    // Performance Observer for Core Web Vitals
    if ('PerformanceObserver' in window) {
      const observer = new PerformanceObserver((list) => {
        for (const entry of list.getEntries()) {
          // Report to analytics
          if (window.gtag) {
            if (entry.entryType === 'largest-contentful-paint') {
              window.gtag('event', 'LCP', {
                value: Math.round(entry.startTime),
                metric_id: 'lcp',
              });
            }
            if (entry.entryType === 'first-input') {
              window.gtag('event', 'FID', {
                value: Math.round(entry.processingStart - entry.startTime),
                metric_id: 'fid',
              });
            }
          }
        }
      });

      observer.observe({ entryTypes: ['largest-contentful-paint', 'first-input'] });
    }
  }, []);
};

const App = () => {
  useAppInitialization();

  return (
    <QueryClientProvider client={queryClient}>
      <ErrorBoundary>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/aplikacie" element={<Applications />} />
              <Route path="/dobrovolnictvo" element={<Dobrovolnictvo />} />
              <Route path="/navstevy" element={<VisitorsGuide lang="sk" />} />
              <Route path="/visitors" element={<VisitorsGuide lang="en" />} />
              <Route path="/whistleBlower" element={<WhistleBlower />} />
              <Route path="/whistleblower" element={<WhistleBlower />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </TooltipProvider>
      </ErrorBoundary>
    </QueryClientProvider>
  );
};

export default App;